export default "__VITE_ASSET__CcFiXovV__"